module.exports = __webpack_public_path__ + "static/media/location-obstacle.844134c8.png";